jQuery(document).ready(function($) {
var item_qty = $('#instafeed').attr('items'),
	token = $('#access_token').val(),
	user_id = token.substr(0, token.indexOf('.'));

var userFeed = new Instafeed({
    get: 'user',
    userId: user_id,
    limit: item_qty,
    resolution: 'standard_resolution',
    accessToken: token,
    sortBy: 'most-recent',
    template: '<a href="{{link}}" target="_blank"><div class="ig-gallery item"><img src="{{image}}" class="img-responsive" /></div></a>',
    target: 'instafeed',
    after: function() {

	$(document).ready(function() {
		$('div#instafeed.owl-carousel').owlCarousel({
		    loop:true,
		    margin:0,
		    nav:true,
		    responsive:{
		        0:{
		            items:1
		        },
		        600:{
		            items:3
		        },
		        1000:{
		            items:5
		        }
		    }
		});
	});
    }

});
userFeed.run();
});